import { useLocation, Navigate, Outlet } from "react-router-dom"
import { useSelector } from "react-redux"
import { selectCurrentToken } from "./authSlice"

const RequireAuth = () => {
    const lsToken = JSON.parse(localStorage.getItem('userdata'));
    
    const token = useSelector(selectCurrentToken)
    const location = useLocation()
    console.log(token);
    return (
        token
            ? <Outlet />
            : <Navigate to="/login" state={{ from: location }} replace />
    )
}
export default RequireAuth